// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsFranchises_DeletarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for DELETE /payments/accounts/deletar/{id}
 *
 * Locally composed boolean acknowledgement payload.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubaccountsFranchises_DeletarResponseDados {
deleted: boolean
}

export type SubaccountsFranchises_DeletarResponse = ApiResponse<SubaccountsFranchises_DeletarResponseDados>;

registerResponseContract('SubaccountsFranchises_DeletarResponse', {
  deleted: { type: 'boolean', required: true },
})
